import { IconSolidAI } from "@kalodata/kds-design-icons";
import { useAppDispatch, useAppSelector } from "@hooks/redux";
import { formatCurrency, getGasStationPrice } from "@pages/pricing/utils";
import { USER_BIZ_COUNTRY_MAP } from "@src/config/country";
import { SELECTED_SUBSCRIBE_PRODUCT, updateSubscribeProducts } from "@store/memberCenterSlice";
import { InputNumber } from "antd";
import { Trans } from "react-i18next";

export default ({ product, index }: { product: SELECTED_SUBSCRIBE_PRODUCT; index: number }) => {
  const dispatch = useAppDispatch();
  const { language } = useAppSelector((state) => state.globalReducer);
  const currency = "USD";
  const { selectedProducts } = useAppSelector((state) => state.memberCenterReducer);

  const onchange = (value: number | null) => {
    const products = [...selectedProducts];
    products[index] = {
      ...products[index],
      quantity: value || 1,
    };
    dispatch(updateSubscribeProducts(products));
  };

  const { userInfo } = useAppSelector((state) => state.globalReducer);
  const bizCountry = userInfo.bizCountry;

  return (
    <div
      className="flex items-center justify-between gap-[16px] py-[16px] border-t border-b border-kds-border mt-[16px]"
      id={product.itemId}
    >
      <div className="flex items-center gap-[4px] text-kds-fg text-[16px]">
        <IconSolidAI size={16} className="shrink-0 text-[#FFB727]" />
        <span className="font-bold">{100 * product.quantity}</span>
        <Trans>Credits</Trans>
      </div>
      <div className="flex items-center gap-[4px] text-kds-fg-soft text-[16px]">
        {formatCurrency(
          getGasStationPrice(product.key, USER_BIZ_COUNTRY_MAP[bizCountry], currency, product.realprice),
          USER_BIZ_COUNTRY_MAP[bizCountry],
          currency,
          language,
        )}
        <span>/</span>
        {product.unit}
      </div>
      <div className="right">
        <InputNumber mode="spinner" min={1} defaultValue={1} style={{ width: 140 }} onChange={onchange} />
      </div>
    </div>
  );
};
